import {
  praseOnboardingItem,
  parseStandardItem,
  parsePracticeItem,
  praseMysteryItem,
} from './parsers';

/**
 * CurriculumManager: Unmask That
 *
 * Reads data from JSON formatted curriculum.
 *
 * Context:
 * Unmask That requires students to complete
 * items and use their responses to those items
 * to complete a minigame (a mystery).
 *
 * To progress through the game, students
 * need to correctly complete 6 items per level.
 * There is an item bank of 6 items per level
 * and 4 practice items per level.
 */

class CurriculumManager {
  constructor() {
    // Initially, no curriculm is loaded
    this.curriculum = {};
    // Onboarding data
    this.onboarding = {};
    // A paragraph
    this.mystery = [];
    // A standard set corresponds to a specific mystery
    this.standardSets = [];
    // A practice set corresponds to a specific level
    this.practiceSet = [];
    // Icons for standard and mystery items
    this.icons = [];
  }

  init(curriculumJson) {
    this.curriculum = curriculumJson;
  }

  populateOnboarding() {
    this.onboarding = praseOnboardingItem(this.curriculum.onboarding);
  }

  populateStandardSets(level) {
    const levelData = this.curriculum.mysteries[level - 1];
    this.mystery = praseMysteryItem(levelData.mystery);
    this.standardSets = levelData.standardSets.map((standardSet, contentSide) =>
      standardSet.map((sentence, i) => parseStandardItem(sentence, i, levelData.uuids[contentSide])),
    );
    this.icons = levelData.icons;
  }

  populatePracticeSet(level) {
    const levelData = this.curriculum.practiceItems[level - 1].slice();
    this.practiceSet = levelData.map(data => parsePracticeItem(data));
  }

  getOnboarding() {
    return this.onboarding;
  }

  getMystery() {
    return this.mystery;
  }

  getStandardSet(standardSetIndex = 0) {
    return this.standardSets[standardSetIndex];
  }

  getPracticeSet() {
    return this.practiceSet;
  }

  getIcons() {
    return this.icons;
  }
}

export default CurriculumManager;
